<!-- <div *ngIf="loading" class="app-loader">
    <div class="loader-content">
        <h2>CA Manager</h2>
        <div class="d-flex align-items-center  justify-content-center">
            Loading...
        </div>
    </div>
</div> -->
<ngx-spinner bdColor = "rgba(229,226,226,0.8)" size = "large" color = "#1890ff" type = "timer" [fullScreen] = "true"><p style="color: #1890ff" > Loading... </p></ngx-spinner>
<router-outlet></router-outlet>